<template>
  <div class="kamis-container">
    <div class="kamis-box-container" id="kamisBox"></div>
  </div>
</template>

<script>
import { getCookie } from 'thsc-ifind-stock-f9/packages/assets/js/util.js';
import amisInit, { amisRemoteEmbed } from '@king-fisher/2c-amis-next';
export default {
  name: 'Main',
  methods: {},
  async mounted() {
    const kamisEnv = getCookie('kamisEnv');
    const url = new URL(window.location.href);
    const paramsFromUrl = url.searchParams;
    const token = paramsFromUrl.get('token');
    if (!token) {
      return;
    }
    const systemId = paramsFromUrl.get('systemId') || '595';
    await amisInit('prod');
    window.React = window.amisRequire('react');
    window.ReactDOM = window.amisRequire('react-dom');
    await amisRemoteEmbed('#kamisBox', {
      env: kamisEnv || paramsFromUrl.get('env') || 'prod',
      token: token,
      systemId: systemId,
    });
  },
};
</script>

<style lang="less">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
html,
body {
  width: 100%;
  min-height: 100%;
}
body {
  font-family: '微软雅黑';
  font-size: 14px;
}
.kamis-container {
  width: 100%;
  height: 100%;
}
.kamis-box-container {
  width: 100%;
}
</style>
